import { ShieldCheck, TrendingUp, Zap } from 'lucide-react'

import { Checklist } from '@/routes/Public/marketing/components/Checklist'
import { ValueProp } from '@/routes/Public/marketing/components/ValueProp'
import { Demo, DsSection } from '../primitives'

export function ValuePropsSection() {
  return (
    <DsSection
      id="value-props"
      title="Value props & checklist"
      marketing
      intro={
        <>
          The <code>&lt;ValueProp&gt;</code> and <code>&lt;Checklist&gt;</code> components, used on the
          marketing Insurance page.
        </>
      }
    >
      <Demo label="ValueProp · 3-up">
        <div className="grid gap-8 md:grid-cols-3">
          <ValueProp icon={<Zap />} title="Fast quotes">
            Real quotes from multiple carriers in minutes, not days of phone calls.
          </ValueProp>
          <ValueProp icon={<ShieldCheck />} title="Stay compliant">
            We watch filings and deadlines so nothing lapses while you drive.
          </ValueProp>
          <ValueProp icon={<TrendingUp />} title="Move faster">
            One place for policies, certificates, and claims — no paperwork chase.
          </ValueProp>
        </div>
      </Demo>
      <Demo label="ValueProp · on dark">
        <div className="bg-ink-800 grid gap-8 p-8 md:grid-cols-3">
          <ValueProp onDark icon={<Zap />} title="Fast quotes">
            Real quotes from multiple carriers in minutes, not days of phone calls.
          </ValueProp>
          <ValueProp onDark icon={<ShieldCheck />} title="Stay compliant">
            We watch filings and deadlines so nothing lapses while you drive.
          </ValueProp>
          <ValueProp onDark icon={<TrendingUp />} title="Move faster">
            One place for policies, certificates, and claims — no paperwork chase.
          </ValueProp>
        </div>
      </Demo>
      <Demo label="Checklist">
        <Checklist
          items={['Auto liability', 'Motor truck cargo', 'Physical damage', 'Non-trucking liability']}
        />
      </Demo>
    </DsSection>
  )
}
